import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import ReactDOM from 'react-dom';
import { UI_EVENTS, EngineState } from 'playable/dist/src/constants';
import { createSettingsButtonContainer } from './components/SettingsButton/SettingsButton';
import { createSettingsPopoverContainer } from './components/SettingsPopover/SettingsPopover';
import { ModuleUI } from './components/ModuleUI';
import { defaultTexts } from './useTexts';
const QUALITIES = [240, 360, 480, 720, 1080, 1440, 2160, 4320];
export class SettingsModule {
  constructor(dependencies) {
    this.dependencies = dependencies;
    _defineProperty(this, "isFullScreen", false);
    _defineProperty(this, "mainUIVisible", false);
    _defineProperty(this, "config", {});
    _defineProperty(this, "qualities", []);
    _defineProperty(this, "dummyContainer", document.createElement('div'));
    _defineProperty(this, "settingsPopover", createSettingsPopoverContainer());
    _defineProperty(this, "settingsButton", createSettingsButtonContainer());
    _defineProperty(this, "selectedQuality", void 0);
    _defineProperty(this, "handleReadyToPlay", () => {
      const adapter = this.getPlaybackAdapter();
      if (!(adapter != null && adapter.hls)) {
        return;
      }
      adapter.hls.on('hlsLevelSwitched', () => {
        this.selectedQuality = this.getSelectedQuality();
        this.render();
      });
      this.qualities = adapter.hls.levels.map((level, index) => ({
        level: index,
        name: this.getQualityName(level.height)
      }));
      this.qualities.push(this.getAutoQuality());
      this.selectedQuality = this.getSelectedQuality();
      this.render();
    });
    _defineProperty(this, "initSettings", config => {
      var _config$texts;
      const {
        rootContainer,
        bottomBlock,
        tooltipService,
        eventEmitter
      } = this.dependencies;
      this.config = config;
      rootContainer.appendComponentElement(this.settingsPopover.element);
      bottomBlock.addControl('settings', this.settingsButton.element);
      tooltipService.createReference(this.settingsButton.element, {
        text: ((_config$texts = config.texts) == null ? void 0 : _config$texts.buttonTooltip) || defaultTexts.buttonTooltip
      });
      eventEmitter.on(UI_EVENTS.FULL_SCREEN_STATE_CHANGED, this.handleFullScreenChanged);
      eventEmitter.on(UI_EVENTS.MAIN_BLOCK_HIDE, () => this.handleMainUIVisibility(false));
      eventEmitter.on(UI_EVENTS.MAIN_BLOCK_SHOW, () => this.handleMainUIVisibility(true));
      eventEmitter.on(EngineState.READY_TO_PLAY, this.handleReadyToPlay);
      this.render();
    });
    _defineProperty(this, "handleSpeedChange", rate => {
      const {
        onSpeedChange
      } = this.config;
      this.dependencies.engine.setPlaybackRate(rate);
      if (onSpeedChange) {
        onSpeedChange(rate);
      }
    });
    _defineProperty(this, "handleFullScreenChanged", isFullScreen => {
      this.isFullScreen = isFullScreen;
      this.render();
    });
    _defineProperty(this, "handleMainUIVisibility", visible => {
      this.mainUIVisible = visible;
      this.render();
    });
    _defineProperty(this, "handleQualityChange", quality => {
      const {
        onQualityChange
      } = this.config;
      const {
        hls
      } = this.getPlaybackAdapter();
      this.selectedQuality = quality;
      if (hls) {
        hls.nextLevel = quality.level;
      }
      if (onQualityChange) {
        const biQualityName = quality.level === -1 ? 'auto' : quality.name;
        onQualityChange(biQualityName);
      }
      this.render();
    });
  }
  getPlaybackAdapter() {
    return this.dependencies.nativeOutput.attachedAdapter;
  }
  getAutoQuality() {
    var _this$config$texts;
    return {
      level: -1,
      name: ((_this$config$texts = this.config.texts) == null ? void 0 : _this$config$texts.autoQualityTitle) || defaultTexts.autoQualityTitle
    };
  }
  getSelectedQuality() {
    const adapter = this.getPlaybackAdapter();
    const hls = adapter == null ? void 0 : adapter.hls;
    if (!hls) {
      return;
    }
    const {
      currentLevel,
      autoLevelEnabled
    } = hls;
    if (autoLevelEnabled) {
      return this.getAutoQuality();
    }
    const level = hls.levels[currentLevel];
    return {
      level: currentLevel,
      name: this.getQualityName(level.height)
    };
  }
  getAPI() {
    return {
      initSettings: this.initSettings
    };
  }
  getQualityName(height) {
    for (const quality of QUALITIES) {
      if (height <= quality) {
        return quality + 'p';
      }
    }
    return height + 'p';
  }
  render() {
    this.settingsPopover.updatePosition(this.isFullScreen);
    ReactDOM.render( /*#__PURE__*/React.createElement(ModuleUI, {
      buttonContainer: this.settingsButton.element,
      popoverContainer: this.settingsPopover.element,
      isFullScreen: this.isFullScreen,
      config: this.config,
      mainUIVisible: this.mainUIVisible,
      selectedQuality: this.selectedQuality,
      onSpeedChange: this.handleSpeedChange,
      onQualityChange: this.handleQualityChange,
      qualities: this.qualities
    }), this.dummyContainer);
  }
}
_defineProperty(SettingsModule, "dependencies", ['bottomBlock', 'eventEmitter', 'rootContainer', 'engine', 'tooltipService', 'nativeOutput']);
//# sourceMappingURL=module.js.map